import { ReactNode } from 'react';

import { cn } from '@/utils/tailwind';

import {
  CELL_PADDING,
  MAX_CELL_HEIGHT,
} from '../../DatasetSessionCompare.utils';
import { DEFAULT_COLUMN_WIDTHS, REFERENCE_COLUMN_IDX } from '../../constants';
import { isInPlayground } from '../../utils/isInPlayground';

interface OutputsCellProps {
  isReferenceOutputHidden: boolean;
  isTextTruncated: boolean;
  backgroundStyles: string;
  columnWidthStorage: number[];
  hoverButton: ReactNode;
  outputContent: ReactNode;
  columnIndex?: number;
}

export function OutputsCell({
  isReferenceOutputHidden,
  isTextTruncated,
  backgroundStyles,
  columnWidthStorage,
  hoverButton,
  outputContent,
  columnIndex,
}: OutputsCellProps) {
  const resolvedColumnIndex = columnIndex ?? REFERENCE_COLUMN_IDX;
  const width =
    columnWidthStorage[resolvedColumnIndex] ?? DEFAULT_COLUMN_WIDTHS;
  const inPlayground = isInPlayground();
  return (
    !isReferenceOutputHidden && (
      <td
        className={cn(
          'group relative border-b border-r border-secondary transition-colors',
          !isTextTruncated && 'align-top',
          backgroundStyles
        )}
        data-column={resolvedColumnIndex}
        style={{
          width,
          maxWidth: width,
          minWidth: width,
          ...CELL_PADDING(inPlayground ? 'lg' : 'sm'),
        }}
      >
        <div
          className={cn(
            'flex h-full items-start',
            isTextTruncated && 'flex flex-row justify-between',
            !isTextTruncated && inPlayground && `overflow-y-auto`
          )}
          style={{
            maxHeight:
              !isTextTruncated && inPlayground ? MAX_CELL_HEIGHT : undefined,
          }}
        >
          {outputContent}
        </div>

        {hoverButton}
      </td>
    )
  );
}
